import { render, staticRenderFns } from "./delayDialog.vue?vue&type=template&id=fd923f84&scoped=true&"
import script from "./delayDialog.vue?vue&type=script&lang=js&"
export * from "./delayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd923f84",
  null
  
)

export default component.exports